import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // 登录页
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  // 分享码注册页
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册' }
  },
  // 忘记密码页
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { title: '忘记密码' }
  },
  // 会员首页
  {
    path: '/member',
    name: 'MemberHome',
    component: () => import('@/views/member/Home.vue'),
    redirect: '/member/share-notice',
    children: [
      {
        path: 'share-notice',
        name: 'ShareNotice',
        component: () => import('@/views/member/ShareNotice.vue'),
        meta: { title: '消息' }
      },
      {
        path: 'my-notice',
        name: 'MyNotice',
        component: () => import('@/views/member/MyNotice.vue'),
        meta: { title: '消息' }
      },
      {
        path: 'teafriend',
        name: 'TeaFriend',
        component: () => import('@/views/member/TeaFriend.vue'),
        meta: { title: '茶友' }
      },
      {
        path: 'discover',
        name: 'Discover',
        component: () => import('@/views/member/Discover.vue'),
        meta: { title: '发现' }
      },
      {
        path: 'profile',
        name: 'MemberProfile',
        component: () => import('@/views/common/Profile.vue'),
        meta: { title: '我的' }
      }
    ]
  },
  // 管理员首页
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('@/views/admin/Home.vue'),
    redirect: '/admin/notice',
    children: [
      {
        path: 'notice',
        name: 'AdminNotice',
        component: () => import('@/views/admin/Notice.vue'),
        meta: { title: '公告' }
      },
      {
        path: 'memberManage',
        name: 'MemberManage',
        component: () => import('@/views/admin/MemberManage.vue'),
        meta: { title: '好友管理' }
      },
      {
        path: 'memberStats',
        name: 'MemberStats',
        component: () => import('@/views/admin/MemberStats.vue'),
        meta: { title: '好友统计' }
      },
      {
        path: 'article',
        name: 'AdminArticle',
        component: () => import('@/views/admin/Article.vue'),
        meta: { title: '发现文章' }
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: () => import('@/views/common/Profile.vue'),
        meta: { title: '我的' }
      }
    ]
  },
  // 公告详情页（通用）
  {
    path: '/notice-detail/:noticeId',
    name: 'NoticeDetail',
    component: () => import('@/views/common/NoticeDetail.vue'),
    meta: { title: '公告详情' }
  },
  // 公告编辑页
  {
    path: '/notice-edit/:noticeId?',
    name: 'NoticeEdit',
    component: () => import('@/views/common/NoticeEdit.vue'),
    meta: { title: '编辑公告' }
  },
  // 文章详情页
  {
    path: '/article-detail/:articleId',
    name: 'ArticleDetail',
    component: () => import('@/views/common/ArticleDetail.vue'),
    meta: { title: '文章详情' }
  },
  // 文章编辑页
  {
    path: '/article-edit/:articleId?',
    name: 'ArticleEdit',
    component: () => import('@/views/common/ArticleEdit.vue'),
    meta: { title: '编辑文章' }
  },
  // 会员工具页（独立页面，不带tabbar）
  {
    path: '/admin/memberTools',
    name: 'MemberTools',
    component: () => import('@/views/admin/MemberTools.vue'),
    meta: { title: '会员工具' }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 茶余饭后` : '茶余饭后'

  const isLoggedIn = store.getters.isLoggedIn

  // 未登录只能访问登录、注册和忘记密码页
  if (!isLoggedIn && to.path !== '/login' && to.path !== '/register' && to.path !== '/forgot-password') {
    next('/login')
    return
  }

  // 已登录访问登录页、注册页或忘记密码页，自动跳转
  if (isLoggedIn && (to.path === '/login' || to.path === '/register' || to.path === '/forgot-password')) {
    const userType = store.getters.userType
    next(userType === '0' ? '/admin' : '/member')
    return
  }

  // 管理员不能访问会员页面
  if (isLoggedIn && store.getters.isAdmin && to.path.startsWith('/member')) {
    next('/admin')
    return
  }

  // 会员不能访问管理员页面
  if (isLoggedIn && store.getters.isMember && to.path.startsWith('/admin')) {
    next('/member')
    return
  }

  next()
})

export default router
